// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyA2JHOzT5e8t45DOYFbh6HozsdFWvcMoRw",
    authDomain: "private-healthcare-12b74.firebaseapp.com",
    projectId: "private-healthcare-12b74",
    storageBucket: "private-healthcare-12b74.appspot.com",
    messagingSenderId: "1027963140989",
    appId: "1:1027963140989:web:91935e54a98feec311aa14"
};

export default firebaseConfig;